import { getAccountId } from "./CookieHandler";

export function getSkyFlagUrl() : string {
  const baseUrl = getBaseUrl();
  const accountId = getAccountId();
  return `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}suid=${accountId}`;
}

export function getBaseUrl(): string {

  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

  if (/android/i.test(ua)) {
    return process.env.REACT_APP_SKY_FLAG_URL_ANDROID!;
  }

  if (/iPad|iPhone|iPod/.test(ua) || 
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return process.env.REACT_APP_SKY_FLAG_URL_IOS!;
  }

  return process.env.REACT_APP_SKY_FLAG_URL_PC!;
}